import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Card, Typography, useThemeValue } from '@altermaind/web/ui';
import { Routes } from '@/_shared/constants/routes';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { useSurvey } from '@/surveys/state';

type Props = {
  hasInvalid: boolean;
  completed?: number;
};

/**
 * @deprecated
 * Not in use
 */
export const NoEmployees: FC<Props> = ({ hasInvalid, completed }) => {
  const t = useTranslations('dashboard.noEmployees');
  const gapXs = useThemeValue('space', 'xs');
  const navigate = useNavigate();
  const { genericResponsiveValue } = useResponsiveStyle();

  const goToEmployees = () => {
    navigate(Routes.People);
  };

  const goToReview = () => {
    navigate(Routes.PeopleReview);
  };

  const { goToSurveySoftSkill } = useSurvey();

  return (
    <Box
      display='flex'
      flexDirection={genericResponsiveValue({
        breakPoints: { desktop: 'row' },
        defaultValue: 'column',
      })}
      style={{ gap: gapXs }}
    >
      {!hasInvalid && (
        <Card flex='2'>
          <Typography variant='h2' mb='xs'>
            {t('employees.title')}
          </Typography>
          <Typography variant='p2/light'>{t('employees.description')}</Typography>
          <Button data-testid='go-to-employees' onClick={goToEmployees} variant='positive' mt='m'>
            {t('employees.cta')}
          </Button>
        </Card>
      )}
      {hasInvalid && (
        <Card flex='2'>
          <Typography variant='h2' mb='xs'>
            {t('reviewData.title')}
          </Typography>
          <Typography variant='p2/light'>{t('reviewData.description')}</Typography>
          <Button onClick={goToReview} variant='positive' mt='m'>
            {t('reviewData.cta')}
          </Button>
        </Card>
      )}
      <Card flex='1'>
        <Typography variant='h2' mb='xs'>
          {t('surveys.title')}
        </Typography>
        <Typography variant='p2/light'>{t('surveys.description')}</Typography>
        <Button
          data-testid='go-to-survey'
          onClick={goToSurveySoftSkill}
          disabled={completed === 0}
          variant='positive'
          mt='m'
        >
          {t('surveys.cta')}
        </Button>
      </Card>
    </Box>
  );
};
